
import React from 'react'
// import Header from './Header'
import Routes from './Routes'
// import Footer from './Footer'
// import { Container } from 'semantic-ui-react'

import "../../../scss/index.scss"

export default () => (
	<Routes />
	// <div className="application">
	// 	<div>
	// 		<Header />
	// 		<Container style={{ minHeight: '219px', marginBottom: '5rem' }}>
	// 			<Routes />
	// 		</Container>
	// 		<Footer />
	// 	</div>
	// </div>
)


// WEBPACK FOOTER //
// ./src/features/ui/components/App.js